import React from 'react';
import { createBrowserHistory } from 'history';
import { BrowserRouter, Switch } from 'react-router-dom';
import { GuardProvider, GuardedRoute } from 'react-router-guards';
import { checkUserLogged } from './guards/checkUserLogged';
import { NotFound, PageError } from '../pages';
import { routes } from './routes';

export const prefix = '';
const qrcodePrefix = '/qrcode';

const isFluxoQrCode = () => {
  const { pathname } = window.location;

  return pathname === qrcodePrefix || pathname.startsWith(`${qrcodePrefix}/`);
};

export const montarCaminho = (path: string) => {
  const normalizedPath = `${prefix}${path}`;

  if (!isFluxoQrCode()) return normalizedPath;

  return normalizedPath === '/' ? qrcodePrefix : `${qrcodePrefix}${normalizedPath}`;
};

const getRoutePaths = (path: string) => {
  const normalizedPath = `${prefix}${path}`;

  if (normalizedPath === '/') {
    return [normalizedPath, qrcodePrefix];
  }

  return [normalizedPath, `${qrcodePrefix}${normalizedPath}`];
};

export const Router = () => {
  return (
    <BrowserRouter>
      <GuardProvider guards={[checkUserLogged]} error={PageError}>
        <Switch>
          {routes.map((route) => (
            <GuardedRoute
              key={route.name}
              path={getRoutePaths(route.path)}
              exact={route.exact}
              component={route.component}
              meta={route.meta}
            />
          ))}

          <GuardedRoute path="*" component={NotFound} />
        </Switch>
      </GuardProvider>
    </BrowserRouter>
  );
};

export default Router;

export const history = createBrowserHistory();
